'use strict'

import './ProductReviewConsultantComment.css'
import React from 'react'

/**
 * [ID] => 2890
 * [POST_ID] => 16168
 * [PARENT_ID] => 2888
 * [POST_TEXT] => Отлично! :)
 * [AUTHOR_ID] => 32950
 * [AUTHOR_NAME] =>
 * [AUTHOR_EMAIL] =>
 * [NAME] => Юрий
 * [LAST_NAME] => Тест
 * [AUTHOR_GROUPS_ID] => 3
 * [AUTHOR] => Юрий Тест
 * [DATE_TIME] => 18.07.2022 14:48:11
 *
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function ProductReviewConsultantComment (props) {
  return (
    <div className="answer-text-holder" style={{display: 'block'}}>
      <div className="answer-text-block consultant">
        <div className="consultant__text-block">
          <span className="icon"><i className="consultant-ic-logo"/></span>
          <div className="consultant__text">
            <div className="testimonial-head">
              <div className="name-block">
                <span className="name">{props.getMessage('CONSULTANT_ANSWER')}</span>
                <span className="date">{props.DATE_CREATE}</span>
              </div>
            </div>
            <div className="testimonial-text" dangerouslySetInnerHTML={{__html: props.POST_TEXT}}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductReviewConsultantComment